export default "__VITE_ASSET__C81g0fmi__";